import { createSelector, createSlice } from "@reduxjs/toolkit";

const applicationSlice = createSlice({
    name: "applicaiton",
    initialState: {
        applicationList: { data: [], pagination: null, userList: [] },
        currentApplication: null,
        singleApplication: null,
        applicationNotes: [],
        applicationLogs: [],
        statusCount: [],
    },
    reducers: {
        saveApplication: (state) => { },
        createApplication: (state) => { },
        createdApplicaiton: (state, action) => {
            state.applicationList.data.push(action.payload);
        },

        listApplication: (state) => { },
        listedApplications: (state, action) => {
            state.applicationList = action.payload;
        },

        getStatusCount: () => { },
        storeStatusCount: (state, action) => {
            state.statusCount = action.payload
        },

        getSingleApplication: (state) => { },
        storeSingleApplication: (state, action) => {
            //console.log(action.payload);
            state.singleApplication = action.payload
        },

        updateApplication: (state, action) => {

        },

        updateApplicationStatus: (state) => { },
        updatedApplication: (state, action) => {
            let a = []
            state.applicationList?.data?.map(d => {
                if (d?._id === action.payload?._id) a.push(action.payload)
                else a.push(d)
            })

            state.applicationList.data = a;
        },

        deleteApplication: (state) => { },
        deletedApplication: (state, action) => { },


        syncApplication: (state, action) => {
            state.currentApplication = action.payload;
        },


        createNotes: () => { },
        createDNotes: (state, action) => {
            state.applicationNotes = [...state.applicationNotes, action.payload]
        },
        fetchNotes: (state) => { state.applicationNotes = [] },
        storeNotes: (state, action) => {
            state.applicationNotes = action.payload
        },

        assignNewUser: () => { },



        fetchLogs: (state) => { state.applicationLogs = [] },
        storeLogs: (state, action) => {
            state.applicationLogs = action.payload
        },
        // replaceFileChange:(state,action)=>{
        //     //console.log(action.payload);
        //     const {fileName,data}=action.payload;
        //     state.singleApplication[fileName]={
        //         name:data?.name,
        //         originalName:data?.originalName,
        //         updatedAt:data?.updatedAt,
        //         ...state.singleApplication[fileName],
        //     }
        // },

        clearAllApplication: (state) => {
            state.applicationList = { data: [], pagination: null }
            state.currentApplication = null
            state.singleApplication = null
            state.applicationLogs = []
            state.applicationNotes = []
        }
    }
})


export const {
    saveApplication,
    createApplication,
    createdApplicaiton,
    listApplication,
    listedApplications,
    getStatusCount,
    storeStatusCount,
    getSingleApplication,
    storeSingleApplication,
    updateApplication,
    updateApplicationStatus,
    assignNewUser,
    updatedApplication,
    deleteApplication,
    deletedApplication,
    syncApplication,


    createNotes,
    createDNotes,
    fetchNotes,
    storeNotes,
    fetchLogs,
    storeLogs,

    // replaceFileChange,
    clearAllApplication
} = applicationSlice.actions

export const applicationSelector = createSelector(
    state => state.application,
    application => application
);


export const applicationStatusCount = createSelector(
    state => state.application,
    application => application.statusCount
);

export default applicationSlice.reducer